import { motion } from "framer-motion";

function Banner({ game }) {
  const type = game?.type;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 3, delay: 0.4 }}
      className="grid mx-4 mt-0"
    >
      <div className="flex items-center justify-center">
        <img
          src={
            game?.[type]?.length > 0
              ? game?.[type][0]?.image_url
              : "/image/spin.png"
          }
          alt="game_banner"
          className="rounded-t-[20px] rounded-b-[150px]"
          loading="lazy"
        />
      </div>
    </motion.div>
  );
}

export default Banner;
